import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import * as actions from '../authActions';
import CheckEmailForm from './CheckEmailForm';

const CheckEmailFormContainer = ({
  authReducer,
  checkEmail,
  hideAuthenticationModal,
}) => {
  const { requestingCheckEmail } = authReducer;

  return (
    <CheckEmailForm
      id="Auth-CheckEmailForm"
      checkEmail={checkEmail}
      isRequesting={requestingCheckEmail}
      hideAuthenticationModal={hideAuthenticationModal}
    />
  );
};

const mapStateToProps = state => ({
  authReducer: state.authReducer,
});

export default connect(
  mapStateToProps,
  actions
)(CheckEmailFormContainer);
